<template>
  <div class="header-controls">


    <div class="right-control">



      <profile-avatar-button></profile-avatar-button>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import ProfileAvatarButton from "./elements/ProfileAvatarButton";

export default {
  name: "TheHeader",
  components: {ProfileAvatarButton},
  computed: {
    ...mapState("menu", {
      opened: (state) => state.opened,
    }),
    ...mapState("session", {
      session: (state) => state.session,
    }),
    title() {
      return this.$route.meta.title;
    },
    sessionBtn() {

      return (this.$route.name !== 'session.create')
    },
  },
  methods: {
    ...mapMutations({
      setOpened: "menu/SET_OPENED",
    }),
    setMenuOpened(opened) {
      this.setOpened(opened);
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 500);
    },
    goPage(index) {
      if (index === this.$route.name) {
        new Error("Navigation Duplicated");
        return;
      }

      this.$router.push({
        name: index,
      });
    },
    goBack() {
      if (this.$route.meta.back === 'HISTORY_BACK')
        this.$router.go(-1)
      else if (this.$route.meta.back)
        this.$router.push({name: this.$route.meta.back});
    },
    goSession() {
      this.$router.push({name: "session.create"})
    }
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 350px) {
  .el-page-header {
    display: block;

    &__content {
      padding: 15px 0 0 0;
      color: #fff;
    }
  }
}

.page-header {
  padding: 18px;
  margin-bottom: 0;
  color: #fff;

  &_root .el-page-header__left {
    display: none !important;
  }
}

.hide-menu-control {
  color: #ffffff;
}

.header-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: inherit;
  float: right;

  .menu-control {
    color: #363636;
    margin-left: 5px;
    padding: 10px 5px;
  }
}

.right-control {
  &__session {
    margin-right: 10px;
  }
}
</style>
<style>
.el-page-header__content {
  color: #fff;
}

.page-header_root .el-page-header__left {
  display: none;
}
</style>
